import { ReactNode, useState } from "react";
import useInterval from "use-interval";
import classNames from "classnames";
import { Asset } from "../../types/Asset";
import "./style.scss";

function SimpleSlideshow({
  images,
  delay = 2000,
  playing = false,
  rewindOnPause = false,
  className = "",
  children
}: {
  images?: Asset[];
  delay?: number;
  playing?: boolean;
  rewindOnPause?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const [curIndex, setCurIndex] = useState(0);

  useInterval(
    () => {
      if (playing && images) {
        setCurIndex(curIndex => (curIndex + 1) % images.length);
      } else {
        if (rewindOnPause) setCurIndex(0);
      }
    },
    delay > 0 ? delay : false
  );

  function makeURL(url: string | Asset) {
    if (typeof url !== "string") {
      return url.styles?.preview || "";
    }
    return url;
  }

  return (
    <div className="simpleSlideshow">
      {images?.map((image, idx) => {
        const imageUrl = makeURL(image);
        const imageClasses = classNames(className, "simpleSlideshow-image", {
          "simpleSlideshow-show": curIndex === idx
        });
        const backgroundImage = `url(${imageUrl})`;
        return (
          <div
            key={imageUrl}
            className={imageClasses}
            style={{ backgroundImage }}
          />
        );
      })}
      {children}
    </div>
  );
}

export default SimpleSlideshow;
